// Источник токенов — localStorage (в Telegram-webview cookie ненадёжны:
// SameSite/partitioned режут доступ). Транспорт на axios + requestInterceptor,
// но токен читаем/пишем здесь, а не в cookie.
const KEY = "tokens";

export function getTokens() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    localStorage.removeItem(KEY);
    return null;
  }
}

export function getAccessToken() {
  return getTokens()?.access_token || null;
}

export function setTokens(data) {
  if (data?.access_token) localStorage.setItem(KEY, JSON.stringify(data));
}

export function clearTokens() {
  localStorage.removeItem(KEY);
}
